import React from "react";
import "./Portfolio.css";
import posthog from "posthog-js";

const Portfolio = () => {
  const enabled = posthog.isFeatureEnabled("portfolio_enabled");

  if (!enabled) {
    return(
      <section className="pageWrap">
      <div className="pageContainer">
        <h1 className="pageHeading">Our Portfolio</h1>
        <p className="pageText">
          Page is in development stage, Stay Tuned.
        </p>
      </div>
    </section>
    );
  }

  return (
    <section className="pageWrap">
      <div className="pageContainer">
        <h1 className="pageHeading">Our Portfolio</h1>
        <p className="pageText">
          Explore some of the digital products, websites, mobile applications,
          and technology solutions we have crafted for clients worldwide. Every
          project reflects our commitment to quality, innovation, and user-focused
          design.
        </p>
      </div>
    </section>
  );
};

export default Portfolio;
